<template>
  <div>
    <div class="sm:px-10 md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
      <BackButton @back="back('transfer-property')" />
      <!-- <pre>
       {{selection}}
     </pre> -->
      {{ $route.meta.details }}
      <v-card>
        <v-card-title primary-title>
          {{ title }}
        </v-card-title>
        <v-card-text class="px-10">
          <div>
            Select One:
            <v-item-group>
              <v-container>
                <div class="md:flex justify-evenly w-full">
                  <div
                    class="md:w-1/2 mr-4 my-4"
                    v-for="(item, n) in selection"
                    :key="n"
                    md="4"
                  >
                    <v-item v-slot="{ active, toggle }">
                      <v-card
                        :color="active ? 'primary' : ''"
                        class="d-flex align-center"
                        height="150"
                        @click="toggle"
                      >
                        <v-scroll-y-transition>
                          <div
                            :class="active ? 'text-white' : 'text-gray-700'"
                            class="
                              text-2xl
                              md:text-sm
                              sm:text-md
                              lg:text-md
                              px-4
                              py-4
                              align-align-top
                              flex
                              font-bold
                              h-full
                              w-full
                            "
                          >
                            {{ item.title }}
                          </div>
                        </v-scroll-y-transition>
                      </v-card>
                    </v-item>
                  </div>
                </div>
              </v-container>
            </v-item-group>
          </div>
          <div class="my-1">
            Indicate the specific details of the new / requested property or
            house model.
          </div>
          <div>
            Note: This request category is not for upgrading or downgrading. The
            Contract Price must be the same.
          </div>
          <div class="my-4 border border-gray-500 w-full">
            <input type="text" class="px-4 py-2 w-full" placeholder="Project" />
          </div>
          <div class="md:flex">
            <div class="w-1/2">
              <div>House and lot / Lot only</div>
              <div
                class="border-gray-900 border-2 mb-1 mr-2"
                v-for="(item, i) in house"
                :key="i"
              >
                <input
                  class="py-1 px-4 w-full"
                  type="text"
                  :placeholder="item.placeholder"
                />
              </div>
            </div>
            <div class="w-1/2">
              <div>Condominium / Parking</div>
              <div
                class="border-gray-900 border-2 mb-1"
                v-for="(item, i) in condo"
                :key="i"
              >
                <input
                  class="px-4 py-1 w-full"
                  type="text"
                  :placeholder="item.placeholder"
                />
              </div>
            </div>
          </div>
          <div class="w-full border border-gray-500 my-4">
            <textarea
              placeholder="Justification (Limit to 300 characters only)"
              class="px-4 py-2 w-full h-full"
            ></textarea>
          </div>
          <div>
            Any separate requests indicated in the ‘Justification’ will not be
            acknowledged for processing.
          </div>
        </v-card-text>
      </v-card>
      <v-card class="my-1">
        <v-card-title primary-title> Upload Sample Computation </v-card-title>
        <v-card-text>
          <div>
            Upload your signed Sample Computation and/or the signed House Layout
            and Perspective of the property where you are requesting to transfer
            to. You may get the mentioned documents from your authorized
            Seller/Broker.
          </div>
          <div class="my-1 flex items-center">
            <div class="border border-gray-500 w-1/2">
              <input type="text" class="w-full px-4 py-2" />
            </div>
            <v-btn color="lightblue">Add attachment</v-btn>
          </div>
          <div class="my-1 flex items-center">
            <div class="border border-gray-500 w-1/2">
              <input type="text" class="w-full px-4 py-2" />
            </div>
            <v-btn color="lightblue">Add attachment</v-btn>
          </div>
          <div class="my-1 flex items-center">
            <div class="border border-gray-500 w-1/2">
              <input type="text" class="w-full px-4 py-2" />
            </div>
            <v-btn color="lightblue">Add attachment</v-btn>
          </div>

          <input type="text" />
          <input type="text" />
        </v-card-text>
      </v-card>
      <v-card class="my-1">
        <v-card-text>
          <div>
            <v-card-title primary-title>
              Reminders and guidelines
            </v-card-title>
            <ul>
              <li>
                1. A processing fee amounting to Php 50,000.00 will be charged
                should your request be approved by Management.
              </li>
              <li>
                2. You will need to continue your payments based on your current
                approved purchase and current payment terms even if you have
                submitted a request.
              </li>
              <li>
                3. Once submitted, you may see the status of your request on
                your Dashboard.
              </li>
            </ul>
          </div>
        </v-card-text>
      </v-card>

      <!-- component for axios submit -->
      <AlertDialog
        :props_data="props_data"
        :showAlert="showAlert"
        @alertDialogSubmit="alertDialogSubmit"
      />
      <div class="my-2 w-full">
        <v-btn class="w-full" color="blue" @click="submitTicket">
          Submit Request</v-btn
        >
      </div>
      <!-- ================== -->
    </div>
  </div>
</template>

<script>
import AlertDialog from "../../common/AlertDialog.vue";
import BackButton from "@/common/BackButton.vue";
export default {
  data() {
    return {
      props_data: {},
      showAlert: false,
      house: [
        {
          placeholder: "Phase",
        },
        {
          placeholder: "Block",
        },
        {
          placeholder: "Lot",
        },
        {
          placeholder: "House Model",
        },
      ],
      condo: [
        {
          placeholder: "Building",
        },
        {
          placeholder: "Unit Number",
        },
      ],
      title: "Transfer to a different property / Change house model",
      selection: [
        {
          title:
            "Transfer to a different property with the same contract price",
          id: 1,
        },
        {
          title: "Change the house model with the same contract price",
          id: 2,
        },
        {
          title:
            "Transfer to a different property and change house model with the same contract price",
          id: 3,
        },
      ],
    };
  },
  methods: {
    back(n) {
      this.$router.push({ name: n });
    },
    submitTicket() {
      this.showAlert = true;
      this.props_data = {
        status_id: 1,
        remarks_id: 2,
        classification_id: 3,
        department_id: 4,
        subject: 5,
      };
    },
    alertDialogSubmit(name) {
      this.showAlert = false;
      !this.$route.path.includes(name) ? this.$router.push(name) : null;
    },
  },
  components: {
    AlertDialog,
    BackButton,
  },
};
</script>
<style scoped>
.selection:hover {
  background: rgb(152, 4, 4);
  color: #fff;
}
.selection:active {
  background: rgb(116, 3, 3);
}
</style>